import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { useHistory, Link } from 'react-router-dom';
import classNames from 'classnames';
import { Button, CircularProgress } from '@material-ui/core';
import './Login.css';
import Popup from '../components/Popup';
import { login } from '../Backend/firebase/auth';
import db, { auth, googleProvider } from '../Backend/firebase/firebase';
import { useDispatch } from 'react-redux';
import { loginSave, logoutSave } from '../DataStore/Slices/userSlice';
import CustomAlert from '../components/CustomAlert';
import { sleep } from '../components/Models/CommonFunc';
import ForgotPassword from '../components/ForgotPassword';
import { Helmet } from 'react-helmet';

function Login() {
    const { register, handleSubmit, reset, errors } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [openPopup, setOpenPopup] = useState(false);
    const dispatch = useDispatch();
    const history = useHistory();
    const [openNotify, setOpenNotify] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const [verifyCaptcha, setVerifyCaptcha] = useState(false);

    const handleCaptchaVerification = (response) => {
        if (response) {
            setVerifyCaptcha(true);
        }
        else {
            setVerifyCaptcha(false);
        }
    };

    const routeOnLogin = async (user) => {
        const token = await user.getIdTokenResult();
        const rolessRef = db.collection("Users").doc(user.uid);
        const doc = await rolessRef.get();
        if (!doc.exists) {
            console.log('No such document!');
            logoutUser();
        }
        else {
            var roleData = doc.data();
            dispatch(loginSave({
                user: roleData
            }));

            if (token.claims.admin) {
                history.push('/users');
            } else {
                if (window.location.pathname === '/') {
                    history.push('/');
                } else {
                    history.push(window.location.pathname);
                }
            }
        }
    }

    const onSubmit = async (data) => {
        // if (verifyCaptcha) {
        let user;
        setIsLoading(true);
        try {
            user = await login(data);
            const rolessRef = db.collection("Users").doc(user.uid);
            const doc = await rolessRef.get();
            var roleData = doc.data();
            if (roleData.userRole === 'Retailer') {
                setNotificationMessage('You are using candidate login, please go to retailer login and try again!');
                setOpenNotify(true);
                setAlertType('error');
                setIsLoading(false);
                await sleep(2000);
                await logoutUser();
            } else {
                // if (user && user.emailVerified) {
                if (user) {
                    await routeOnLogin(user);
                    reset();
                } else {
                    setIsLoading(false);
                    if (user) {
                        user.sendEmailVerification().then((resp) => {
                            history.push('/emailalert');
                        }).catch(function (error) {
                            console.log('Something => ', error);
                            if (error.code === 'auth/too-many-requests')
                                history.push('/emailalert');
                        });
                    }
                }
            }
        } catch (error) {
            if (error.code === 'auth/user-not-found') {
                setNotificationMessage('User is not found!');
                setOpenNotify(true);
                setAlertType('error');
            } else {
                setNotificationMessage(error.message);
                setOpenNotify(true);
                setAlertType('error');
            }
        }
        // } else {
        //     setNotificationMessage('Please verify the captcha first!');
        //     setOpenNotify(true);
        //     setAlertType('error');
        // }
    };

    const loginWithGoogle = async () => {
        var message = '';
        let firebaseUser = null;
        await auth.signInWithPopup(googleProvider)
            .then(async ({ user }) => {
                firebaseUser = user;
            })
            .catch(error => message = error.message);

        const rolessRef = db.collection("Users").doc(firebaseUser.uid);
        const doc = await rolessRef.get();
        let isUserExistInDb = false;
        if (!doc.exists) {
            console.log('No such document!');
            dispatch(loginSave({
                user: {
                    name: '',
                    email: '',
                    uid: '',
                    userRole: '',
                    provider: firebaseUser.providerData[0].providerId
                }
            }));
        }
        else {
            isUserExistInDb = true;
            var roleData = doc.data();
            dispatch(loginSave({
                user: {
                    name: roleData.name,
                    email: roleData.email,
                    uid: roleData.uid,
                    userRole: roleData.userRole,
                    provider: firebaseUser.providerData[0].providerId
                }
            }));
        }

        if (!isUserExistInDb) {
            if (message === '') {
                history.push('/register');
            }
            else {
                console.error(message);
            }
        }
        else {
            if (window.location.pathname === '/') {
                history.push('/');
            } else {
                history.push(window.location.pathname);
            }
        }
    };

    // const loginWithLinkedIn = () => {
    //     const uniqueId = uuidv4();
    //     history.push(`${process.env.REACT_APP_AUTH_URL}?response_type=code&client_id=${process.env.REACT_APP_LINKEDIN_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_LINKEDIN_REDIRECT_URL}&state=${uniqueId}&scope=r_liteprofile%20r_emailaddress%20w_member_social`);
    // }

    const logoutUser = async () => {
        var access_token = sessionStorage.getItem('access_token');
        if (access_token) {
            sessionStorage.removeItem('access_token');
        } else {
            await auth.signOut();
        }
        dispatch(logoutSave());
        //window.location.href = '/';
    };

    return (
        <>
            <div className="login">
                <Helmet>
                    <meta name="description" content="Use your credential to login..." />
                    <title>User Login | Kaipsool Pharmatech</title>
                </Helmet>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                        <div className="col-md-12 mb-3">
                            <div className="form-group">
                                <label className="login__textboxLabel">Email Address <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span></label>
                                <input type="email" className={classNames("form-control login__textbox", { "is-invalid": errors.email })}
                                    name="email" placeholder="Email Address" autoComplete="off"
                                    ref={register({ required: 'Please enter your email address!' })} />
                                <small className="form-text text-danger">{errors.email && errors.email.message}</small>
                            </div>
                        </div>
                        <div className="col-md-12 mb-3">
                            <div className="form-group">
                                <label className="login__textboxLabel">Password <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span></label>
                                <input type="password" className={classNames("form-control login__textbox", { "is-invalid": errors.password })}
                                    name="password" placeholder="Password" autoComplete="off"
                                    ref={register({
                                        required: 'Please enter your password!',
                                        minLength: {
                                            value: 6,
                                            message: 'Password should be at least 6 characters!'
                                        },
                                        maxLength: {
                                            value: 100,
                                            message: 'Password should be 15 length maximum!'
                                        }
                                    })} />
                                <small className="form-text text-danger">{errors.password && errors.password.message}</small>
                            </div>
                        </div>
                        <div className="col-sm-12 text-center mt-2">
                            <div className="d-flex justify-content-center">
                                <div className="p-2">
                                    <Button type="submit" variant="contained" color="primary" size="small"
                                        className="login__btn">
                                        {isLoading ? <CircularProgress size={20} /> : 'Sign In'}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <div className="row">
                    <div className="col-sm-12 text-center">
                        <div className="d-flex flex-column">
                            <div className="login__forgotPassword" onClick={() => setOpenPopup(true)}>
                                Forgot Your Password?
                            </div>
                            {/* <div className="login__providersLogin">
                                <Button type="submit" variant="contained" color="primary" size="small"
                                    className="login__btnGoogle" onClick={loginWithGoogle}>
                                    <img src={googleImg} alt="google" className="img-fluid login__btnGoogleImage" />&nbsp;
                                    <span>Sign In with Google</span>
                                </Button>
                                <Button type="submit" variant="contained" color="primary" size="small"
                                    className="login__btnLinkedIn" onClick={event => window.location.href = `${process.env.REACT_APP_AUTH_URL}?response_type=code&client_id=${process.env.REACT_APP_LINKEDIN_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_LINKEDIN_REDIRECT_URL}&state=${uuidv4()}&scope=r_liteprofile%20r_emailaddress%20w_member_social`}>
                                    <LinkedInIcon className="login__btnLinkedInImage" />&nbsp;
                                    <span>Sign In with LinkedIn</span>
                                </Button>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>

            <Popup openPopup={openPopup} setOpenPopup={setOpenPopup} title="Forgot Password">
                <ForgotPassword />
            </Popup>

            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType || 'error'}
                notificationMessage={notificationMessage} />
        </>
    )
}

export default Login
